import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
  NgModuleRef,
  InjectionToken
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import {
  BroadcastApiClient,
  BroadcastTransmissionApiClient,
  BroadcastSubscriberApiClient,
  BroadcastRecipientApiClient,
  BroadcastMessageApiClient,
  BroadcastTemplateSpecificRecipientsApiClient
} from './services';
import { BroadcastApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    broadcastApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    broadcastApiConfig: BroadcastApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('BroadcastApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    BroadcastApiClient,

    BroadcastTransmissionApiClient,

    BroadcastSubscriberApiClient,

    BroadcastRecipientApiClient,

    BroadcastMessageApiClient,

    BroadcastTemplateSpecificRecipientsApiClient
  ]
})
export class BroadcastApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => BroadcastApiConfig
  ): ModuleWithProviders<BroadcastApiModule> {
    return {
      ngModule: BroadcastApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }]
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: BroadcastApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BroadcastApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => BroadcastApiConfig = moduleRef.injector.get<
      any
    >(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new BroadcastApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('broadcastApiConfig')));
    cfgMgr.addApiConfig('broadcastApiConfig', config);
  }
}
